import dynamic from 'next/dynamic';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { createMarkup } from 'app/scripts/utils';

import Container from '../common/Container';
import CloudinaryImage from '../common/CloudinaryImage';
import './awardwinningbar.css';

const Slider = dynamic(() => import('react-slick'));

export default function AwardWinningBar({
  section,
  writetous,
  awardsDot = false,
  newdev = false,
  bgcolor,
  isBgBlack = false,
}) {
  const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section
      className={`awardwinningbar relative z-[1] shadow-[0px_0px_40px_0px_#00000026] ${isBgBlack ? `bg-[#000815] md:py-[15px] py-0` : bgcolor ? 'bg-[#000815] py-[15px]' : 'bg-[linear-gradient(90deg,_#01296C_0%,_#051F36_100%)] py-[15px]'} ${writetous && 'linear-gradient(130deg,_#1200b6_0%,_#000815_15%,_#000000_70%,_#8603bd82_130%)'}`}
    >
      <Container>
        {newdev ? (
          section?.descriptionEditor && (
            <>
              <div
                className={`${bgcolor && 'text-[#ffffff]'}  font-[400] lg:text-[35px] text-[22px] title_hd mb-[20px] leading-tight hidden`}
                dangerouslySetInnerHTML={createMarkup(
                  section?.descriptionEditor
                )}
              ></div>
              <div className="awardslogos">
                <Slider {...settings}>
                  {section?.images?.data?.map(item => (
                    <span key={item?.id}>
                      {item?.attributes?.url && (
                        <CloudinaryImage
                          backendImgUrl={item?.attributes?.url}
                          className="lg:max-w-[120px] lg:max-h-[120px] sm:max-w-[100px] sm:max-h-[100px] max-w-[48px] max-h-[48px]"
                          alt={item?.attributes?.alternativeText}
                          type={'smallimg'}
                        />
                      )}
                    </span>
                  ))}
                </Slider>
              </div>
            </>
          )
        ) : (
          <div
            className={`bg-[#fff] lg:flex lg:justify-between items-center lg:flex-nowrap rounded-[20px] px-[40px] ${awardsDot ? 'py-[10px]' : 'lg:mt-[-60px] mt-[-20px] py-[30px] shadow-[0px_0px_40px_0px_#00000026]'}`}
          >
            <p className="text-[#000000] text-[20px] w-[100%] md:flex md:items-center md:mr-8 lg:mb-0 mb-3 max-w-[320px]">
              Award-Winning Software Engineering & IT Staffing Company
            </p>
            <div className="awardslider">
              <Slider {...settings}>
                {section?.images?.data?.map(item => (
                  <span key={item?.id}>
                    {item?.attributes?.url && (
                      <CloudinaryImage
                        backendImgUrl={item?.attributes?.url}
                        className="sm:max-w-[140px] md:max-w-[130px] sm:max-h-[60px] max-h-[40px]"
                        alt={item?.attributes?.alternativeText}
                        type={'icon'}
                      />
                    )}
                  </span>
                ))}
              </Slider>
            </div>
          </div>
        )}
      </Container>
    </section>
  );
}
